import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const today = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function AgentPerHead() {
  const [week, setWeek] = useState(today);
  const onWeekChange = useCallback((event) => setWeek(event.target.value), []);

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [noActionAgent, setNoActionAgent] = useState(false);
  const onNoActionAgentChange = useCallback(
    (event) => setNoActionAgent(event.target.checked),
    []
  );

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChange = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Week Of"
          type="date"
          value={week}
          size="small"
          onChange={onWeekChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <div className="col-span-2">
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={noActionAgent}
                onChange={onNoActionAgentChange}
                color="primary"
              />
            }
            label="Include No Action Agents"
          />
        </div>
        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Distributor"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Group"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Alphabetically"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        groupBy={orderBy === 1 ? "groupname" : null}
        title="Agent Per Head Report"
        getUrl={() => "/Reports/Report_AgentPerHead"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          DateWeek: week,
          Distributor: distributor,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          NoActionAgent: noActionAgent,
          OrderBy: orderBy,
        })}
        getProcess={(data) =>
          data.map((item) => ({
            ...item,
            totalPlayers:
              item.totalPlayersLocalSports +
              item.totalPlayersLocalHorses +
              item.totalPlayersOnlineSports +
              item.totalPlayersOnlineHorses +
              item.totalPlayersCasino,
            phTotal:
              item.phLocalSports +
              item.phLocalHorses +
              item.phOnlineSports +
              item.phOnlineHorses +
              item.phCasino,
          }))
        }
        getTotals={(data) => ({
          agent: orderBy === 1 ? `Total by ${data?.[0].groupname}` : "Totals",
          pBalance: data.reduce((acc, item) => acc + item.pBalance, 0),
          nBalance: data.reduce((acc, item) => acc + item.nBalance, 0),
          totalPlayersOnlineSports: data.reduce(
            (acc, item) => acc + item.totalPlayersOnlineSports,
            0
          ),
          totalPlayersCasino: data.reduce(
            (acc, item) => acc + item.totalPlayersCasino,
            0
          ),
          totalPlayersOnlineHorses: data.reduce(
            (acc, item) => acc + item.totalPlayersOnlineHorses,
            0
          ),
          totalPlayersLocalSports: data.reduce(
            (acc, item) => acc + item.totalPlayersLocalSports,
            0
          ),
          totalPlayersLocalHorses: data.reduce(
            (acc, item) => acc + item.totalPlayersLocalHorses,
            0
          ),
          totalPlayers: data.reduce((acc, item) => acc + item.totalPlayers, 0),
          phOnlineSports: data.reduce(
            (acc, item) => acc + item.phOnlineSports,
            0
          ),
          phCasino: data.reduce((acc, item) => acc + item.phCasino, 0),
          phOnlineHorses: data.reduce(
            (acc, item) => acc + item.phOnlineHorses,
            0
          ),
          phLocalSports: data.reduce(
            (acc, item) => acc + item.phLocalSports,
            0
          ),
          phLocalHorses: data.reduce(
            (acc, item) => acc + item.phLocalHorses,
            0
          ),
          phTotal: data.reduce((acc, item) => acc + item.phTotal, 0),
        })}
        getGlobalTotals={(data) => ({
          agent: "Totals",
          pBalance: data.reduce((acc, item) => acc + item.pBalance, 0),
          nBalance: data.reduce((acc, item) => acc + item.nBalance, 0),
          totalPlayersOnlineSports: data.reduce(
            (acc, item) => acc + item.totalPlayersOnlineSports,
            0
          ),
          totalPlayersCasino: data.reduce(
            (acc, item) => acc + item.totalPlayersCasino,
            0
          ),
          totalPlayersOnlineHorses: data.reduce(
            (acc, item) => acc + item.totalPlayersOnlineHorses,
            0
          ),
          totalPlayersLocalSports: data.reduce(
            (acc, item) => acc + item.totalPlayersLocalSports,
            0
          ),
          totalPlayersLocalHorses: data.reduce(
            (acc, item) => acc + item.totalPlayersLocalHorses,
            0
          ),
          totalPlayers: data.reduce((acc, item) => acc + item.totalPlayers, 0),
          phOnlineSports: data.reduce(
            (acc, item) => acc + item.phOnlineSports,
            0
          ),
          phCasino: data.reduce((acc, item) => acc + item.phCasino, 0),
          phOnlineHorses: data.reduce(
            (acc, item) => acc + item.phOnlineHorses,
            0
          ),
          phLocalSports: data.reduce(
            (acc, item) => acc + item.phLocalSports,
            0
          ),
          phLocalHorses: data.reduce(
            (acc, item) => acc + item.phLocalHorses,
            0
          ),
          phTotal: data.reduce((acc, item) => acc + item.phTotal, 0),
        })}
      >
        <TableHeaderColumn
          dataSort
          row="0"
          rowSpan="2"
          colSpan="1"
        ></TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="0"
          rowSpan="2"
          colSpan="1"
        ></TableHeaderColumn>

        <TableHeaderColumn
          dataSort
          row="0"
          rowSpan="1"
          colSpan="6"
          className="table-header-groupped-left table-header-groupped-right"
          dataAlign="center"
        >
          Player Count
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="1"
          rowSpan="1"
          colSpan="2"
          className="table-header-groupped-left table-header-groupped-right table-header-groupped-top"
          dataAlign="center"
        >
          Local
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="1"
          rowSpan="1"
          colSpan="3"
          className="table-header-groupped-left table-header-groupped-right table-header-groupped-top"
          dataAlign="center"
        >
          Online
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="1"
          rowSpan="1"
          colSpan="1"
          dataAlign="center"
          className="table-header-groupped-right"
        ></TableHeaderColumn>

        <TableHeaderColumn
          dataSort
          row="0"
          rowSpan="1"
          colSpan="6"
          className="table-header-groupped-left table-header-groupped-right"
          dataAlign="center"
        >
          Perhead Fee / Bonus
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="1"
          rowSpan="1"
          colSpan="2"
          className="table-header-groupped-left table-header-groupped-right table-header-groupped-top"
          dataAlign="center"
        >
          Local
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="1"
          rowSpan="1"
          colSpan="3"
          className="table-header-groupped-left table-header-groupped-right table-header-groupped-top"
          dataAlign="center"
        >
          Online
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="1"
          rowSpan="1"
          colSpan="1"
          dataAlign="center"
          className="table-header-groupped-right"
        ></TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          row="0"
          rowSpan="2"
          colSpan="3"
          dataAlign="center"
        ></TableHeaderColumn>

        {/* REAL COLUMNS */}

        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent" row="2">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agentPerHeadTypeDesc" row="2">
          Per Head Type
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="totalPlayersLocalSports"
          row="2"
          className="table-header-groupped-left"
        >
          Sport
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="totalPlayersLocalHorses"
          row="2"
          className="table-header-groupped-right"
          dataFormat={decimalInvertedReportFormatter}
        >
          Horses
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="totalPlayersOnlineSports"
          row="2"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sports
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="totalPlayersOnlineHorses"
          row="2"
          dataFormat={decimalInvertedReportFormatter}
        >
          Horses
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="totalPlayersCasino"
          row="2"
          className="table-header-groupped-right"
          dataFormat={decimalInvertedReportFormatter}
        >
          Casino
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="totalPlayers"
          row="2"
          className="table-header-groupped-right"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="phLocalSports"
          row="2"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sports
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="phLocalHorses"
          row="2"
          className="table-header-groupped-right"
          dataFormat={decimalInvertedReportFormatter}
        >
          Horses
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="phOnlineSports"
          row="2"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sports
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="phOnlineHorses"
          row="2"
          dataFormat={decimalInvertedReportFormatter}
        >
          Horses
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="phCasino"
          row="2"
          className="table-header-groupped-right"
          dataFormat={decimalInvertedReportFormatter}
        >
          Casino
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="phTotal"
          row="2"
          className="table-header-groupped-right"
        >
          Total
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="pBalance"
          row="2"
          dataFormat={decimalInvertedReportFormatter}
        >
          Prev Bal
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="nBalance"
          row="2"
          dataFormat={decimalInvertedReportFormatter}
        >
          New Bal
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="distributor" row="2">
          Distributor
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default AgentPerHead;
